import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

import { Field } from "src/common/components/Field";
import { FileInput } from "src/common/components/FileInput";

const messages = defineMessages({
	attachments: {
		id: "form.attachments",
		defaultMessage: "Lelet feltöltése"
	}
});

interface AttachmentsProps {
	disabled?: boolean;
	savedFiles?: string[];
	onChangeSavedFiles?(savedFiles: string[]): unknown;
	unsavedFiles: File[];
	onChangeUnsavedFiles(unsavedFiles: File[]): unknown;
}

export const Attachments: React.FunctionComponent<AttachmentsProps> =
	React.memo(
		({
			disabled,
			savedFiles = [],
			onChangeSavedFiles = () => {},
			unsavedFiles,
			onChangeUnsavedFiles
		}) => (
			<Field label={<FormattedMessage {...messages.attachments} />}>
				<FileInput
					disabled={disabled}
					savedFiles={savedFiles}
					onChangeSavedFiles={onChangeSavedFiles}
					unsavedFiles={unsavedFiles}
					onChangeUnsavedFiles={onChangeUnsavedFiles}
				/>
			</Field>
		)
	);
